import React from 'react'

const AdvisoryBoard = () => {
  return (
    <div id='advisory-board' className='py-28 lg:py-32 xl:py-44 px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center bg-white'>
      <div className='w-full max-w-screen-min-screen'>
        <h1 className='text-primary-dark metro-semi uppercase mb-5'>/ Academic Advisory Board</h1>
        <h1 className='text-secondary section-headline domin mb-10 lg:mb-12'>Qlab collaborates with academic researchers across financial econometrics, statistical learning, and market microstructure.</h1>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
          <div className='bg-[#f1f1f1] p-6 metro text-secondary'>Financial Econometrics</div>
          <div className='bg-[#f1f1f1] p-6 metro text-secondary'>Market Microstructure</div>
          <div className='bg-[#f1f1f1] p-6 metro text-secondary'>Applied Machine Learning</div>
          <div className='bg-[#f1f1f1] p-6 metro text-secondary'>Statistical Physics & Modeling</div>
        </div>
      </div>
    </div>
  )
}

export default AdvisoryBoard
